import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import ArticleComponent from '../../demo-components/wellness/article-component';
import { demoArticles } from '../../demo-components/wellness/demo-articles';
import { useScrollToTop } from '../../hooks';

const WellnessArticlePage = () => {
  const { articleId } = useParams<{ articleId: string }>();
  const navigate = useNavigate();

  useScrollToTop();

  const article = demoArticles.find(a => a.id === articleId);

  if (!article) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      }}>
        <h1 style={{ color: '#333', marginBottom: '16px' }}>Article Not Found</h1>
        <p style={{ color: '#666', marginBottom: '24px' }}>The article you're looking for doesn't exist.</p>
        <button
          onClick={() => navigate('/wellness')}
          style={{
            padding: '12px 24px',
            backgroundColor: '#4285F4',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          Back to Wellness
        </button>
      </div>
    );
  }

  const handleBack = () => {
    navigate('/wellness');
  };

  return <ArticleComponent article={article} onBack={handleBack} />;
};

export default WellnessArticlePage;